import { render, staticRenderFns } from "./form1.vue?vue&type=template&id=db1b524e&scoped=true"
import script from "./form1.vue?vue&type=script&lang=js"
export * from "./form1.vue?vue&type=script&lang=js"
import style0 from "./form1.vue?vue&type=style&index=0&id=db1b524e&prod&lang=scss&scoped=true"
import style1 from "./form1.vue?vue&type=style&index=1&id=db1b524e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1b524e",
  null
  
)

export default component.exports